import { FC, useEffect, useState } from "react";
import SelectAndActionsLayout from "../../../components/Layouts/select-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import {
  getCharitiesProgressiveContribution,
  getCharitiesProgressiveContributionFilter,
} from "../../../services/reports";
import { ISelectOption } from "../../../components/UI/SelectInput/types";
import { notificationError } from "../../../services/notification";

const ReportCharitiesProgressiveContribution: FC = () => {
  const [options, setOptions] = useState<ISelectOption[]>([]);
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const initialize = async () => {
      try {
        const filters = await getCharitiesProgressiveContributionFilter();

        const filterOptions = filters.map<ISelectOption>((option) => ({
          name: option.text,
          value: option.value,
        }));

        setOptions(filterOptions);
      } catch (e) {
        if (e instanceof Error) {
          notificationError("Could not get charities progressive contribution filters", e.message);
        } else {
          notificationError("Could not get charities progressive contribution filters");
        }
        setOptions([{name:'', value: ''}])
      }
      setInitialized(true)
    };
    initialize();
  }, []);

  if(!initialized) return <></>

  return (
    <SelectAndActionsLayout
      actions={[
        ActionButtonEnum.REFRESH, 
        ActionButtonEnum.SAVE_PDF, 
        ActionButtonEnum.SAVE_CSV
      ]}
      selectLabel="Jackpot"
      options={options}
      onRefresh={(selected, output) =>
        getCharitiesProgressiveContribution({
          output,
          jackpotHistorySelect: selected,
        })
      }
    />
  );
};

export default ReportCharitiesProgressiveContribution;
